var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("scrollTop", [_c("i", { staticClass: "icon-fa icon-fa-arrow-up" })]),
      _vm._v(" "),
      _vm.modalMapData
        ? _c(
            "EmptyCardModal",
            {
              ref: "cashOutModal",
              attrs: {
                modalData: _vm.modalMapData,
                onModalClose: (reset) => (_vm.modalMapData = null),
                onModalAccept: (reset) => (_vm.modalMapData = null),
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c(
                    "div",
                    [
                      _c("SelectOrdersMap", {
                        attrs: {
                          chiefRunner: 1,
                          noAction: +(+_vm.selectedDivisionId !== 1),
                          divisionId: _vm.selectedDivisionId,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-header" },
          [
            _c("h5", { staticClass: "pull-left" }, [_vm._v("ONLINE ситуация")]),
            _vm._v(" "),
            true || _vm.divisionsUseCards.includes(+_vm.selectedDivisionId)
              ? [
                  _c(
                    "button",
                    {
                      staticClass: "pull-right btn btn-outline-info",
                      on: {
                        click: function ($event) {
                          _vm.modalMapData = { size: "xl" }
                        },
                      },
                    },
                    [_vm._v("Показать заявки на\n          карте\n        ")]
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "flex flex_gap_10" }, [
            _c(
              "div",
              [
                _vm._l(_vm.mixinGetSortedDivisions(1), function (division) {
                  return _c(
                    "div",
                    {
                      key: division.id,
                      staticClass:
                        "btn-group btn-group-toggle divisions_select",
                      class: [{ disabled: _vm.loading }],
                    },
                    [
                      _c("DivisionBtn", {
                        attrs: {
                          loading: _vm.loading,
                          division: division,
                          orderStatuses: _vm.divisionStatuses[division.id],
                          selectedDivision: _vm.selectedDivisionId,
                          showReport: _vm.showDivisionOnline,
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(_vm.mixinGetSortedDivisions(2), function (division) {
                  return _c(
                    "div",
                    {
                      key: division.id,
                      staticClass:
                        "btn-group btn-group-toggle divisions_select",
                      class: [{ disabled: _vm.loading }],
                    },
                    [
                      _c("DivisionBtn", {
                        attrs: {
                          loading: _vm.loading,
                          division: division,
                          orderStatuses: _vm.divisionStatuses[division.id],
                          selectedDivision: _vm.selectedDivisionId,
                          showReport: _vm.showDivisionOnline,
                        },
                      }),
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _vm._l(_vm.mixinGetSortedDivisions(3), function (division) {
                  return _c(
                    "div",
                    {
                      key: division.id,
                      staticClass:
                        "btn-group btn-group-toggle divisions_select",
                      class: [{ disabled: _vm.loading }],
                    },
                    [
                      _c("DivisionBtn", {
                        attrs: {
                          loading: _vm.loading,
                          division: division,
                          orderStatuses: _vm.divisionStatuses[division.id],
                          selectedDivision: _vm.selectedDivisionId,
                          showReport: _vm.showDivisionOnline,
                        },
                      }),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", [
              _vm._m(0),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showAllProjects,
                        expression: "showAllProjects",
                      },
                    ],
                    attrs: { id: "ch_1", type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.showAllProjects)
                        ? _vm._i(_vm.showAllProjects, null) > -1
                        : _vm.showAllProjects,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.showAllProjects,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.showAllProjects = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.showAllProjects = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.showAllProjects = $$c
                          }
                        },
                        _vm.updateOrdersByFilter,
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "pointer", attrs: { for: "ch_1" } },
                    [_vm._v("Показать все проекты")]
                  ),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  [_c("DrugSearch", { attrs: { onSelect: _vm.onSelectDrug } })],
                  1
                ),
                _vm._v(" "),
                _vm._m(2),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.loadedData
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h5", [
                  _vm._v("Будущие заявки, которые не назначены курьеру "),
                  _c("strong", [
                    _vm._v("(" + _vm._s(_vm.orders.doneByManager.length) + ")"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("div", { staticClass: "mb-2 flex justify-content-end" }, [
                    _c("div", { staticClass: "input-group w-50" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.divisionForShift,
                              expression: "divisionForShift",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.divisionForShift = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "0", disabled: "" } },
                            [_vm._v("Выберите дивизион")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.getSortedDivision(), function (d) {
                            return d.id !== _vm.selectedDivisionId
                              ? _c("option", { domProps: { value: d.id } }, [
                                  _vm._v(_vm._s(d.title) + "\n              "),
                                ])
                              : _vm._e()
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "input-group-append" },
                        [
                          _c("LoadingButton", {
                            attrs: {
                              title: "Отправить на выбранный дивизион",
                              className: "btn btn-outline-info",
                              loading: _vm.shiftOrdersLoading,
                              color: _vm.$constants.LOADING_COLOR,
                              onClick: () => _vm.shiftSelectedOrders(),
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("OrdersList", {
                    ref: "freeOrdersList",
                    attrs: {
                      useCheckBox: true,
                      division: _vm.$AllDivisions[_vm.selectedDivisionId],
                      orders: _vm.orders.doneByManager,
                      storeId:
                        _vm.$AllDivisions[_vm.selectedDivisionId].stores[0]
                          .object_id,
                      allowToSendByPost: _vm.postDivisions.includes(
                        _vm.selectedDivisionId
                      ),
                      allowToShiftToPost: _vm.allowToShiftToPost,
                      allOrders: _vm.noSortedOrders.doneByManager,
                      type: "doneByManager",
                      storeStatus: _vm.storeStatusByOrders,
                      storeData: _vm.storeData,
                      motherRelatedStores: _vm.motherRelatedStores,
                      appointedOrdersDrugs:
                        _vm.divisionCalculateAppointedOrders()
                          ? _vm.appointedOrdersDrugs
                          : null,
                      dynamicStoreData: _vm.dynamicStoreData,
                      showStoreData: true,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h5", [
                  !_vm.orders.appointed
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          on: {
                            click: function ($event) {
                              return _vm.showDivisionOnline("appointed")
                            },
                          },
                        },
                        [_vm._v("Показать\n          ")]
                      )
                    : _vm._e(),
                  _vm._v("\n          Назначенные заявки "),
                  _vm.orders.appointed
                    ? _c("strong", [
                        _vm._v("(" + _vm._s(_vm.orders.appointed.length) + ")"),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.loadingList.appointed || _vm.orders.appointed
                ? _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c("pulse-loader", {
                        staticClass: "text-center",
                        attrs: {
                          loading: _vm.loadingList.appointed,
                          color: _vm.loadingColor,
                        },
                      }),
                      _vm._v(" "),
                      _vm.orders.appointed
                        ? [
                            _c("OrdersList", {
                              attrs: {
                                orders: _vm.orders.appointed,
                                dynamicStoreData: _vm.dynamicStoreData,
                                allOrders: _vm.noSortedOrders.appointed,
                                type: "appointed",
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "legend" }, [
      _c("p", [
        _c("span", { staticClass: "span span_1" }),
        _vm._v("не хватает"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "span span_2" }),
        _vm._v("не хватает на всех"),
      ]),
      _vm._v(" "),
      _c("p", [_c("span", { staticClass: "span span_3" }), _vm._v("в дороге")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "ch_2" } }, [
        _vm._v("Показать только выбранный препарат"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info mt-1" }, [
      _c("p", [_vm._v("Просчет динамического остатка")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Фактическое на МСК + текущий склад - предоплаченные всех дивизионов - согласованные"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }